// extracted by mini-css-extract-plugin
export default {"userAvatarCard":"UserAvatarCard_userAvatarCard__l1-6c","userAvatar":"UserAvatarCard_userAvatar__T3bGp"};